(() => {
  if (window.glowCheckoutBound) return;
  window.glowCheckoutBound = true;
  let busy = false;
  const root = window.Shopify?.routes?.root || '/';
  const buttons = () => document.querySelectorAll('[data-glow-buy]');
  const status = () => document.querySelector('[data-glow-status]');
  const reset = () => {
    busy = false;
    buttons().forEach(button => {
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
    });
  };
  window.addEventListener('pageshow', () => {
    reset();
    if (status()) status().textContent = '';
  });
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-glow-buy]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (busy) return;
    const id = link.dataset.variant;
    if (!/^\d+$/.test(id || '')) return;
    busy = true;
    buttons().forEach(button => { button.setAttribute('aria-busy', 'true'); button.setAttribute('aria-disabled', 'true'); });
    if (status()) status().textContent = link.dataset.working || 'Opening secure checkout…';
    const run = async () => {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('cart');
      const cart = await response.json();
      const existing = cart.items.some(item => String(item.variant_id) === id || String(item.properties?._glow_selection) === id);
      if (!existing) {
        const added = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1, properties: { _glow_selection: id } }] })
        });
        if (!added.ok) {
          const error = await added.json().catch(() => ({}));
          throw new Error(error.description || 'add');
        }
      }
      window.location.assign(`${root}checkout`);
    };
    try {
      if (navigator.locks) await navigator.locks.request('holiday-glow-checkout', run);
      else await run();
    } catch (error) {
      reset();
      if (status()) status().textContent = link.dataset.error || 'Checkout could not open. Please review your bag, then try again.';
    }
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-glow-motion]');
    if (!button) return;
    const paused = !document.documentElement.hasAttribute('data-glow-paused');
    document.documentElement.toggleAttribute('data-glow-paused', paused);
    document.querySelectorAll('[data-glow-motion]').forEach(item => {
      item.setAttribute('aria-pressed', String(paused));
      item.textContent = paused ? item.dataset.resume : item.dataset.pause;
    });
  });
})();
